export const backHandler = {
    register: (backButtonHandler: () => void) => document.addEventListener("backbutton", backButtonHandler, false),
    push: () => {},
    handleBack: (fallback: () => void) => fallback(),
};
